import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { label: "País" },
  en: { label: "Country" },
});
